module.exports = __webpack_public_path__ + "img/5.c4f736d4.jpg";